export enum InvalidFormatType {
  Integer = 'integer',
  MinDecimal = 'min_decimal',
  MaxDecimal = 'max_decimal',
  BetweenDecimal = 'between_decimal',
}
